import React, { Component } from 'react';
import * as d3 from 'd3';
import withTitle from '../components/withTitle';
import chart from './d3/d3-rowchart';

class RowChart extends Component {
  constructor(props) {
    super(props);
    this.chart = null;
  }

  componentDidMount() {
    this.chart = chart()
      .width(this.props.width)
      .height(this.props.height)
      .selected(this.props.selected)
      .on('selected', this.props.onSelected);

    const chartContainer = d3.select(this.refs.chart);
    chartContainer.datum(this.props.data).call(this.chart, this.props.isResize);
  }

  componentDidUpdate() {
    this.chart
      .width(this.props.width)
      .height(this.props.height)
      .selected(this.props.selected);

    const chartContainer = d3.select(this.refs.chart);
    chartContainer.datum(this.props.data).call(this.chart, this.props.isResize);
  }

  render() {
    return <div ref="chart" style={{ width: '100%' }} />
  }
}

export default withTitle(RowChart);


// WEBPACK FOOTER //
// ./src/charts/RowChart.js